import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor(private http: CustomHttpService) { }

  createApplication(data:any): Observable<any> {
    return this.http.post(environment.createApplication,data);
  }

  getAllApplication(data:any): Observable<any> {
    return this.http.post(environment.getAllApplication,data);
  }

  deleteApplication(data:any): Observable<any> {
    return this.http.post(environment.deleteApplication,data);
  }

  
}

